import { nextTick, onMounted, onActivated } from "vue";
import { onMountedOrActivated } from "./onMountedOrActivated";
import store from "@/store";

export function SetTheme() {
  onMountedOrActivated(() => {
    if (location.href.indexOf("metawit.cn") > -1) {
      store.commit("theme/SET_themeConfig", {
        colorPrimary: "#0DB8D9",
        wireframe: true,
        colorInfo: "#0DB8D9",
      });
      store.commit("theme/SET_themeName", "green");
      store.commit("theme/SET_systemName", "智汇星河");
    } else {
      store.commit("theme/SET_themeConfig", {
        colorPrimary: "#2F7BFF",
        wireframe: true,
        colorInfo: "#2F7BFF",
      });
      store.commit("theme/SET_themeName", "default");
      store.commit("theme/SET_systemName", "合伙人1号");
    }
  });
}

export function IsZhiHuiXingHe() {
  if (location.href.indexOf("metawit.cn") > -1) {
    return true;
  } else {
    return false;
  }
}
